var React = require('react');
const beerOptions = JSON.parse(document.getElementById('json_beers').value);
import optionNames from './NameMappings'

const costMappings = JSON.parse(document.getElementById('cost-mappings').getAttribute('data_value'));
class SampleSummary extends React.Component {

    constructor() {
        super();
        this.lineItems = this.lineItems.bind(this);
        this.items = this.items.bind(this);
        this.waterChemistrySummary = this.waterChemistrySummary.bind(this);
    }

    items(sample, index) {
        if (sample.totalCost > 0) {
            return (
                <div className="line-items">
                    {this.costs(sample.cost, index)}
                </div>
            )
        } else {
            return (
                <div className="line-items">
                    <i className="grey">No cost</i>
                </div>
            )
        }
    }

    costs(cost, index) {
        let items = [];
        for (let property in cost) {
            const value = cost[property];
            if (value != null && value > 0) {
                items.push((
                    <div key={`${index}-costs-${property}`}>
                        <div className="line-item">{optionNames[property]}</div>
                        <div className="line-cost">${value}</div>
                    </div>
                ))
            }
        }
        return items;
    }

    lineItems() {
        const self = this;
        return this.props.store.samples.map((sample, index)=> {
                return (
                    <div key={index} className={`summary-${index}`}>
                        <div className="sample-summary-header">
                            Beer {index + 1}: <span className='unbold'>{sample.name}</span>
                        </div>
                        { this.items(sample, index) }
                    </div>
                );
        })
    }

    waterChemistrySummary() {
        if(this.props.store.other_options.water_chemistry.checked) {
            return (
                <div className={`water-chemistry-summary`}>
                    <div className="sample-summary-header">
                        Water Chemistry
                    </div>

                    <div className="line-items">
                        <div>
                            <div className="line-item">Water Chemistry</div>
                            <div className="line-cost">${costMappings['water_chemistry']}</div>
                        </div>
                        {
                            this.props.store.other_options.water_chemistry_plus.checked &&
                            <div>
                                <div className="line-item">Water Chemistry Plus</div>
                                <div className="line-cost">${costMappings['water_chemistry_plus']}</div>
                            </div>
                        }
                    </div>

                </div>
            )
        }
    }

    render() {
        return (
            <div className="sample-summary">
                {this.lineItems()}
                {this.waterChemistrySummary()}
            </div>
        );
    }
}

export default SampleSummary